// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__HgZJV","layout_wrapper":"styles_layout_wrapper__Eusxm","main":"styles_main__AR90S","backgroundParent":"styles_backgroundParent__smT21"};